module.exports = __webpack_public_path__ + "img/Maze-loop-201023.c9dd3eab.gif";